import {ssrLazy} from 'ssr/lazy';

export const SuperformLazy = ssrLazy(() => import(/* webpackChunkName: "superform" */ '.'));
